<template>
  <div class="mb-3">
    <label :for="id" class="d-block"
      >{{ label }} <span v-if="required" class="text-danger">*</span></label
    >
    <vee-field
      :name="name"
      :rules="validationRules"
      v-slot="{ field, handleChange, meta }"
    >
      <el-switch
        v-model="switchValue"
        :id="id"
        :active-value="true"
        :inactive-value="false"
        @change="(val) => handleValueChange(val, handleChange)"
      />
    </vee-field>
    <ErrorMessage class="text-danger" :name="name" />
  </div>
</template>

<script setup>
import { ref } from "vue";

const switchValue = ref(false);

const props = defineProps({
  id: {
    type: String,
    required: true,
  },
  name: {
    type: String,
    required: true,
  },
  label: {
    type: String,
    required: true,
  },
  required: {
    type: Boolean,
    default: false,
  },
  fieldName: {
    type: String,
    default: "",
  },
  validationRules: {
    type: [Function, Array, String, Object],
    default: () => () => true,
  },
});

function handleValueChange(val, handleChange) {
  switchValue.value = val;
  handleChange(val);
}
</script>
